import { useContext } from 'react';
import { Card, Field } from '../../../../layouts';
import { OrderStatus } from '../../../../types/enums';
import { formatMoney } from '../../../../utils/string-utils';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function RetailOrderPaymentInfoCard() {

	const { order } = useContext(RetailOrderContext);

	let materialCosts = 0;
	order.details.materialOrders.forEach(mo => {
		if (mo.orderStatusID !== OrderStatus.Cancelled)
			materialCosts += mo.amount;
	});

	return (
		<>
			<Card
				header={'Payment Information'}
				className='payment-info-card field-label-70'
			>
				<Field label={'Order Total'} >{formatMoney(order.details.amount)}</Field>
				<Field label={'Material Costs'} >{formatMoney(materialCosts)}</Field>
				<Field label={'Labor Costs'} className="labor-cost">
					{formatMoney(order.details.amount - materialCosts)}
				</Field>
				{
					order.details.leadCreatedOn &&
					<Field label={'Estimated Sales Comm'}>
						{formatMoney(order.details.scCFIEstAmount)}
					</Field>
				}
			</Card>
		</>
	);
}
